<template>
  <div class="add-menu-wrap">
    <h2>{{menu.smi_id? "Edit Menu" : "Add Menu"}}</h2>
    <!-- <div class="input-wrap">
      <label v-if="!menuImage.value" class="file" for="file">Browse Menu Image</label>
      <input type="file" id="file" @change="getFile" ref="file">
      <span class="file-name">
        <img v-if="menuImage.value" :src="menuImage.value" alt="">
      </span>
      <button class="clear-icon" v-if="menuImage.value" @click="resetImage">Clear Icon</button>
      <span v-for="(error, index) in menuImage.errors" :key="index">{{error}}</span>
    </div> -->
    <div class="input-wrap">
      <label>Menu Name:</label>
      <input type="text" v-model.trim="menuName.value">
      <span v-for="(error, index) in menuName.errors" :key="index">{{error}}</span>
    </div>
    <div class="input-wrap">
      <label>Menu Link (External links only):</label>
      <input type="text" v-model.trim="menuLink.value">
      <span v-for="(error, index) in menuLink.errors" :key="index">{{error}}</span>
    </div>
    <div class="add-button">
      <button @click="emitAddOrEditMenu">{{menu.smi_id? "Edit Menu" : "Add Menu"}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menu: Object
  },
  data () {
    return {
      menuName: {value: this.menu? this.menu.smi_name : '', errors: []},
      menuLink: {value: this.menu? this.menu.smi_link : '', errors: []},
      
    }
  },
  methods: {
    emitAddOrEditMenu () {
      if (this.hasErrors()) {
        return;
      }
      
      let params = {
        smi_name: this.menuName.value,
        smi_link: this.menuLink.value,
      }

      if (this.menu.smi_id) {
        params.smi_id = this.menu.smi_id;
        this.$emit('edit-menu', params);
      } else {
        this.$emit('add-menu', params);
      }
    },
    hasErrors () {
      this.clearErrors();

      let errorCount = 0;
      if (this.menuName.value.length === 0) {
        this.menuName.errors.push('Menu name can\'t be empty.');
        errorCount++;
      }
      if (this.menuName.value.length > 250) {
        this.menuName.errors.push('Please use a shorter name.');
        errorCount++;
      }

      if (this.menuLink.value.length === 0) {
        this.menuLink.errors.push('Menu link can\'t be empty.');
        errorCount++;
      }
      if (this.menuLink.value.length > 250) {
        this.menuLink.errors.push('Please use a shorter link.');
        errorCount++;
      }

      if (errorCount > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearErrors () {
      this.menuName.errors = [];
      this.menuLink.errors = [];
    },
  }
}
</script>

<style scoped>
.add-menu-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.material-icons {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
}
#file {
  display: none;
}
.input-wrap {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  width: 100%;
}
.input-wrap span {
  text-align: center;
  font-size: 0.8em;
  color: red;
  display: block;
}
.input-wrap .file-name {
  color: black;
  max-width: 100%;
}
label.file {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  outline: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
  font-size: 0.8em;
  background: #f68d22;
  color: white;
  text-align: center;
}
.add-button button {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  outline: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
  font-size: 1.2em;
  background: var(--button-color-blue);
  color: white;
  text-align: center;
  margin: 10px 0;
}
.clear-icon {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  outline: none;
  padding: 5px 10px;
  border-radius: 100px;
  font-weight: 600;
  font-size: 0.6em;
  background: var(--button-color-bright-red);
  color: white;
  text-align: center;
  margin: 10px auto;
}
</style>